<template>
  <div
    class="slide"
    :class="{
      selected: isSelected,
      'edit-mode': isEditMode,
    }"
    @click="$emit('selected')"
  >
    <!--  Image start  -->
    <div class="image-wrapper">
      <img src="/display/static/images/tick.svg" class="tick-img" v-show="!isEditMode" />
      <img
        v-if="oldImages"
        :src="getShot"
        :id="item.id"
        class="img-fluid"
        style="left: 0"
        loading="lazy"
        decoding="async"
        :index="!oldImages"
      />
      <img
        v-if="!oldImages"
        :src="getShot"
        :id="item.id"
        class="img-fluid"
        style="left: 0"
        loading="lazy"
        decoding="async"
        :index="oldImages"
      />
    </div>

    <!--  Image end  -->

    <div class="title-screen">

      <span class="title-screen__span"
            v-if="paramsClient.nb_screen_segment!==1"
        ><i v-if="isEmpty" class="fa fa-file-o"></i> {{ item.title}}
      </span>

      <span class="title-screen__span"
            v-if="paramsClient.nb_screen_segment===1 && item.screens "
        ><i v-if="isEmpty" class="fa fa-file-o"></i> {{ item.screens[0].title}}
      </span>
      <span class="title-screen__span"
            v-if="paramsClient.nb_screen_segment===1 && !item.screens "
        ><i v-if="isEmpty" class="fa fa-file-o"></i> {{ item.title}}
      </span>


      <button
        class="btn btn-sm edit-title-btn"
        @click.stop="toggleEditMode()"
        v-show="!isEditMode && isEditable"
      >
        <span class="fa fa-pencil"></span>
      </button>
      <span
        v-if="haveScreen"
        v-show="isHover"
        id="fa-clone"
        class="fa  icon-layers text-right"
      ></span>
      <div v-show="isHover" class="text-center" style="transform: translateY(50%);">
        <b-button
          v-if="haveScreen && !isCollapse2"
          :id="item.id"
          @click="$emit('showSelect', $event)"
          variant="outline-primary"
          class="btn btn-sm edit-title-btn"
          @click.stop=""
          v-show="!isEditMode && isEditable"
          >{{ $t('button.preview') }}
        </b-button>
        <b-button
          v-if="haveScreen && isCollapse2"
          :id="item.id"
          @click="$emit('showSelect2')"
          variant="outline-primary"
          class="btn btn-sm edit-title-btn"
          @click.stop=""
          v-show="!isEditMode && isEditable"
          >{{ $t('button.preview') }}
        </b-button>
      </div>
    </div>
    <div class="duration-screen" v-if="item.duration && !isEmpty && isActiveModule === 'videos'">
      <div :title="item.duration" class=" duration-screen__style">
        {{ getDuration(item.duration) }}
      </div>
    </div>
    <div class="edit-panel" :id="item.id" v-show="ModalSegment">
      <div class="close-btn" @click.stop="toggleEditMode()">&times;</div>
      <div class="form-group">
        <input
          :title="$t('labels.title')"
          :placeholder="$t('placeholder.title')"
          type="text"
          class="form-control form-control-sm"
          v-model="title"
          :maxlength="getmaxLength"
        />
      </div>
      <button
        class="btn btn-primary btn-sm pull-right"
        @click.stop="updateTitleScreen()"
        v-if="!isHover"
      >
        {{ $t('button.edit') }}
      </button>
      <button
        class="btn btn-primary btn-sm pull-right"
        @click.stop="updateSegment()"
        v-if="isHover"
      >
        {{ $t('button.edit') }}
      </button>
    </div>
    <div class="edit-panel" :id="item.id" v-show="ModalSegment != true">
      <div class="close-btn" @click.stop="toggleEditMode()">&times;</div>
      <div class="form-group">
        <input
          :title="$t('labels.title')"
          :placeholder="$t('placeholder.title')"
          type="text"
          class="form-control form-control-sm"
          v-model="titleSlide"
          :maxlength="getmaxLength"
        />
      </div>
      <button class="btn btn-primary btn-sm pull-right" @click.stop="update()">
        {{ $t('button.edit') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import mixin from '../../mixins/Mixin.js';
import { bus } from '../../main';
import lazy from 'vue-lazyload';
import lazyComponent from 'vue-lazyload';
export default {
  name: 'SlideCard',
  props: {
    title: '',
    ModalSegment: {
      type: Boolean,
      default: false,
    },
    Shot: '',
    item: Object,
    haveScreen: Boolean,
    isSelected: Boolean,
    isCollapse2: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isHover: {
      type: Boolean,
    },
    isActiveModule: String,
    oldImages: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    lazy,
  },
  components: {
    lazyComponent,
  },
  mixins: [mixin],
  data() {
    return {
      isEditMode: false,
      titleSlide: this.item.title,
      screenShot:
        'data:image/png;base64,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',
    };
  },
  created() {},
  mounted() {
    bus.$on('displaycreenShot', module => {
      this.screenShot = '/display/static/images/icons/modules/' + module + '-card.svg';
    });
  },
  computed: {
    ...mapGetters({
      getmaxLength: 'common/getmaxLength',
      paramsClient: 'getParamsClients',

    }),
    getScreenShot() {
      this.screenShot =
        'data:image/png;base64,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';
      return this.screenShot;
    },

    getShot() {
      return this.Shot ? this.Shot : this.getScreenShot;
    },
  },
  methods: {
    ...mapActions('slides', ['updateTitle']),
    ...mapActions('segments', ['updateTitleSegment', 'updateTitleScreenInSegment']),
    toggleEditMode() {
      this.isEditMode = !this.isEditMode;
    },

    // Modal SlideList
    updateTitleScreen() {
      this.updateTitleScreenInSegment({ ...this.item, title: this.title });
      this.toggleEditMode();
    },
    updateSegment() {
      this.updateTitleSegment({ ...this.item, title: this.title });
      this.toggleEditMode();
    },

    // Other Modal
    update() {
      this.updateTitle({ ...this.item, title: this.titleSlide });
      this.toggleEditMode();
    },

  },
};
</script>

<style lang="scss" scoped>
#btn-show {
  border-color: #eee;
  padding: 5px 20px;
}
#fa-clone {
  display: block;
  float: right;
}
.container {
  max-width: 300px;
}

.image-wrapper {
  position: relative;
  padding-bottom: 56.2%;
  /* Skeleton placeholder shown while the (lazy) thumbnail loads, so the grid
     never flashes blank. The loaded image (object-fit: cover) covers it. */
  background: linear-gradient(100deg, #eef0f3 30%, #e2e5ea 50%, #eef0f3 70%);
  background-size: 200% 100%;
  animation: slidecard-skeleton 1.4s ease-in-out infinite;
}
@keyframes slidecard-skeleton {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.image-wrapper img {
  position: absolute;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.slide {
  position: relative;
  margin: 0 0 30px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.16);
  border-radius: 3px;
  overflow: hidden;
  transition: 0.1s ease-in-out;
  min-height: 80px;
  cursor: pointer;
  &:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    .edit-title-btn {
      opacity: 1 !important;
      visibility: visible !important;
      background: rgba(26, 147, 240, 0.6);
    }
    .title-screen {
      background: rgba(26, 147, 240, 0.6);
      height: 10em;
    }
  }
  &:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    transition: 0s ease-in-out;
  }
  &.selected {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    .buttons-container {
      opacity: 0;
      visibility: hidden;
    }
    &:before {
      background: rgba(26, 147, 240, 0.6);
      z-index: 1;
    }
    .title-screen {
      background: none;
      z-index: 1;
    }
    .tick-img {
      display: block;
    }
  }
  &.edit-mode {
    .edit-panel {
      opacity: 1;
      visibility: visible;
    }
    &:before {
      z-index: 0;
    }
  }
  .tick-img {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    margin: 8px;
    display: none;
    cursor: pointer;
  }
  .title-screen {
    width: 100%;
    height: 100%;
    position: absolute;
    font-weight: bold;
    text-align: left;
    padding: 0.5em;
    color: #ffffff;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
    height: 4em;
    top: 0;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    .edit-title-btn {
      opacity: 0;
      visibility: hidden;
      transition: all 0.2s;
    }
  }
  .duration-screen {
    float: left;
    position: absolute;
    left: 5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 12px;
    padding: 0px 0px !important;
    /* top: 0; */
    bottom: 4px;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    &__style {
      background: rgba(0, 0, 0, 0.5);
      border-radius: 3px;
      justify-content: center;
      color: #ffffff;
      padding: 1px 3px;
    }
  }
  button {
    color: #ffffff !important;
  }
  .edit-panel {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    padding: 1.5em 0.5em 0.5em;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s;
    .close-btn {
      position: absolute;
      right: 0;
      padding: 0.5em;
      top: 0;
      height: 25px;
      width: 25px;
      line-height: 0.8em;
      color: #333333;
      cursor: pointer;
      &:hover {
        color: #f44336;
      }
    }
    .btn-primary {
      color: #fff;
      background-color: #1a93f0;
      border-color: #1a93f0;
    }
  }
  .image-wrapper {
    .img-fluid {
      width: 100%;
    }
  }
  .title-screen__span{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// SlideCard.vue?5327911c